import layout from '../layout'
export default function makeTagRoutes({
  contentType,
  components: { UserListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/`,
          component: UserListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
